// extracted by mini-css-extract-plugin
export default {"Spinner":"FilesTable_Spinner__siUHI","NoFiles":"FilesTable_NoFiles__LT4iy"};